import React from 'react'
import PropTypes from 'prop-types'

import {
  _DetailKeyContainer, _Col, _TitleValueBlock,
  valueDivClassCss,
} from './styles.js'


const PropertyType = ({ data, areaName }) => {
  const tenancyTypes = data.data?.attributes?.housing_tenancy?.variables

  const propertyTypes = data.data?.attributes?.housing_type?.variables

  const attachedType = []
  const duplexType = []
  const highriseType = []

  propertyTypes.forEach(type => {
    if(type.variable === 'single_detached') attachedType.push({ ...type, title: 'Detached' })
    if(type.variable === 'semi_detached') attachedType.push({ ...type, title: 'Semi Detached' })
    if(type.variable === 'duplex') duplexType.push({ ...type, title: 'Duplex' })
    if(type.variable === 'apartment_1_to_4_floors') highriseType.push({ ...type, title: 'Low-Rise Apartment' })
    if(type.variable === 'apartment_5_plus_floors') highriseType.push({ ...type, title: 'High-Rise Apartment' })
  })
  return (
    <div>
      <h4>{areaName} Tenancy & Property Type</h4>

      <_DetailKeyContainer>
        <_Col xs={6} md={3} withBg>
          {
            tenancyTypes && tenancyTypes.map(type => (
              <_TitleValueBlock
                title={type.variable === 'owners' ? 'Owned' : 'Rented'}
                value={`${Math.round(type.value * 100)}%`}
                valueDivClassCss={valueDivClassCss}
                key={type.label}
                withBg
              />
            ))
          }
        </_Col>

        <_Col xs={6} md={3}>
          {
            attachedType && attachedType.map(type => (
              <_TitleValueBlock
                title={type.title}
                value={`${Math.round(type.value * 100)}%`}
                valueDivClassCss={valueDivClassCss}
                key={type.label}
              />
            ))
          }
        </_Col>

        <_Col xs={6} md={3}>
          {
            duplexType && duplexType.map(type => (
              <_TitleValueBlock
                title={type.title}
                value={`${Math.round(type.value * 100)}%`}
                valueDivClassCss={valueDivClassCss}
                key={type.label}
              />
            ))
          }
        </_Col>

        <_Col xs={6} md={3}>
          {
            highriseType && highriseType.map(type => (
              <_TitleValueBlock
                title={type.title}
                value={`${Math.round(type.value * 100)}%`}
                valueDivClassCss={valueDivClassCss}
                key={type.label}
              />
            ))
          }
        </_Col>

      </_DetailKeyContainer>
    </div>
  )
}


PropertyType.propTypes = {
  data: PropTypes.shape({
    data: PropTypes.shape({
      attributes: PropTypes.shape({
        housing_tenancy: PropTypes.shape({
          variables: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        housing_type: PropTypes.shape({
          variables: PropTypes.arrayOf(PropTypes.shape({})),
        }),
      }),
    }),
  }),
  areaName: PropTypes.string,
}

export default PropertyType
